import styled from 'styled-components'

export const Container = styled.div`
    height: 100%;
    .bottom{
        height: calc(100% - 42px);
        overflow-y: scroll;
    }
`